import Controller from "properjs-controller";

export const EventBus = new Controller();
